import animationEndEvent from '../events/animation';

class PreloaderIntroView {
  constructor() {
    this.container = document.querySelector('.preloader')

    if (!this.container) {
      return;
    }

    this.html = document.querySelector('html')
    this.revealer = this.container.querySelector('.revealer')
    // this.logo = this.container.querySelector('.logo')
    this.header = document.querySelector('.header')
    this.previousPercentage = 0

    this.startPromise = null
    this.finishPromise = null
    this.revealedPromise = null
  }

  updateProgress(percentage) {
    // // Play the logo animation once the percentage hits 100
    // if (percentage == 100) {
    //   this.logo.classList.add('loaded')
    // }

    // this.previousPercentage = percentage
  }

  start({ skipLogoAnimation, fullPageTransition } = {}) {

    this.skipLogoAnimation = skipLogoAnimation;
    this.fullPageTransition = fullPageTransition;

    if (!this.container) {
      return Promise.resolve();
    }

    if (this.startPromise) {
      return this.startPromise
    }

    let logoPromise
    if (this.skipLogoAnimation) {
      this.revealer.classList.add('init-reveal')
      logoPromise = Promise.resolve()
    } else {
      // Trigger the logo animation to begin playing
      // this.logo.classList.add('loaded')
      logoPromise = new Promise((resolve, reject) => {
        this.initRevealComplete = (e) => {
          if (e.animationName == 'soft-out') {
            this.revealer.classList.add('init-reveal')
            resolve('init-reveal-complete')
          }
        }

        // this.logo.addEventListener(animationEndEvent, this.initRevealComplete)
      })
    }

    this.startPromise = Promise.all([logoPromise])
    return this.startPromise;
  }

  finish() {
    const curtainAnimation = this.fullPageTransition ? 'page-curtain-finish-full' : 'page-curtain-finish'
    const curtainCompleteClass = this.fullPageTransition ? 'complete-reveal--full' : 'complete-reveal'

    let revealStartPromise = new Promise((resolve, reject) => {
      this.revealStartHandler = (e) => {
        // this.logo.classList.add('u-display-none')
        this.container.classList.add(curtainCompleteClass)
        this.html.classList.add('complete-body-transition')
        resolve()
      }

      this.revealer.addEventListener(animationEndEvent, this.revealStartHandler)
    })

    let revealCompletePromise = new Promise((resolve, reject) => {

      this.revealCompleteHandler = (e) => {
        if (e.animationName == curtainAnimation) {
          this.hide()
          this.reset()
          this.header.classList.add('revealed')
          resolve()
        }
      }

      this.container.addEventListener(animationEndEvent, this.revealCompleteHandler)
    })

    this.finishPromise = Promise.all([revealStartPromise, revealCompletePromise])
    return this.finishPromise
  }

  reset() {
    this.startPromise = null
    this.finishPromise = null
    this.revealer.classList.remove('init-reveal')
    // this.logo.classList.remove('loaded')
    // this.logo.classList.remove('u-display-none')
    this.container.classList.remove('complete-reveal')
    this.container.classList.remove('complete-reveal--full')

    document.body.classList.remove('u-overflow-hidden')

    this.html.classList.remove('body-transition')
    this.html.classList.remove('complete-body-transition')

    this.revealer.removeEventListener(animationEndEvent, this.revealStartHandler)
    // this.logo.removeEventListener(animationEndEvent, this.initRevealComplete)
    this.container.removeEventListener(animationEndEvent, this.revealCompleteHandler)
  }

  hide() {
    this.container.classList.remove('init-load')
    this.container.classList.remove('reveal')
    document.body.classList.remove('u-overflow-hidden')

    this.html.classList.remove('body-transition')
    this.html.classList.remove('complete-body-transition')
  }

  show() {
    this.html.classList.add('body-transition')
    document.body.classList.add('u-overflow-hidden')

    this.container.classList.add('reveal')
    this.header.classList.remove('revealed')
  }
}

export default PreloaderIntroView
